module.exports = __webpack_public_path__ + "static/media/strange1.5cae8e0a.png";